<template>
  <div class="c-mission__container">
    <div class="c-mission">
      <div class="c-mission__header">
        <span class="c-mission__type">{{ type }}</span>
        <img :src="icon" alt="" class="c-mission__icon" />
      </div>
      <div class="c-mission__content">
        <p class="c-mission__title">{{ title }}</p>
      </div>
    </div>
    <div class="c-mission__points__container">
      <div class="c-mission__points_box">
        <span class="c-mission__points__text">+ {{ points }} punti</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    points: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins";

.c-mission__container {
  position: relative;
  background-color: white;
  border-radius: 15px;
  height: 100%;
  margin: 1rem 0;
  color: black;
  width: 290px;
  @include md {
    min-width: 350px;
  }
  @include lg {
    min-width: auto;
    padding: 0 0.5rem;
  }
  @include xl {
    min-width: 350px;
    padding: 0 0.5rem;
  }
}

.c-mission {
  display: flex;
  flex-direction: column;
}
.c-mission__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.c-mission__icon {
  height: 30px;
}
.c-mission__points__container {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
}
.c-mission__content {
  height: 200px;
  padding: 1rem;
  padding-top: 0.3rem;
}
.c-mission__title {
  font-weight: 600;
  font-size: 20px;
  @include xl {
    font-size: 25px;
  }
}
.c-mission__type {
  font-weight: 600;
  font-size: 12px;
  @include xl {
    font-size: 15px;
  }
}
.c-mission__points_box {
  background-color: #6221e6;
  border-radius: 2px;
  padding: 1rem 2rem;
  width: 100%;
  border-top-left-radius: 15px;
  border-bottom-right-radius: 15px;
  font-weight: 600;
  color: white;
}
</style>
